import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { SET_TICKET_DETAILS } from "../../actions/types";

import right from "../../svg/chevron_right.svg";

class SupportCard extends Component {
  /**
   * takes date as paramater and returns the date in DD MMM YYYY
   */
  formatDate(date) {
    var monthNames = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec"
    ];
    date = new Date(date);
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + " " + monthNames[monthIndex] + " " + year;
  }

  /**
   * it sends the title and description of the ticket clicked to the store
   */
  saveTicketTitle() {
    let dataToSend = {
      title: `Support Ticket #${this.props.displayData.id}`,
      status: this.props.displayData.status
    };
    this.props.setHeadetDetails(dataToSend);
  }

  render() {
    var descMessage = "",
      displayStatus = false,
      unread = false;
    if (this.props.displayData.status === 2) {
      descMessage =
        "Created on " + this.formatDate(this.props.displayData.created_at);
      displayStatus = true;
      unread = true;
    } else if (this.props.displayData.status === 4) {
      descMessage =
        "Solved on " + this.formatDate(this.props.displayData.updated_at);
      displayStatus = false;
      unread = true;
    } else if (this.props.displayData.status === 3) {
      descMessage = "Pending";
      displayStatus = true;
      unread = true;
    } else if (this.props.displayData.status === 4) {
      descMessage =
        "Closed on " + this.formatDate(this.props.displayData.updated_at);
    }
    const updateTS =
      this.props.displayData && this.props.displayData["updated_at"];
    const newTicket = updateTS > this.props.helpTS && unread;
    const style = newTicket ? { fontWeight: "bold" } : {};
    return (
      <Link
        className={
          displayStatus
            ? "help-support-card-container"
            : "help-support-card-container opacity-50"
        }
        to={"/ticket/" + this.props.displayData.id}
        onClick={this.saveTicketTitle.bind(this)}
        style={style}
      >
        <div className="help-support-card">
          <div className="help-support-card-title">
            Support Ticket #{this.props.displayData.id}{" "}
            {newTicket ? <div className="green-dot" /> : null}
          </div>
          <div className="help-support-card-desc">{descMessage}</div>
        </div>
        <div className="help-support-card-icon">
          <img src={right} alt="" />
        </div>
      </Link>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeadetDetails: headerData => {
      dispatch({
        type: SET_TICKET_DETAILS,
        payload: headerData
      });
    }
  };
};

const mapStateToProps = ({ helpTS }) => ({ helpTS });
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportCard);



// WEBPACK FOOTER //
// ./src/components/Landing/SupportCard.js